import {
  isPublish,
  requestUrls
} from '../../base/vars.js';
import { getLogLocale } from '../../base/utils.js';

class Logging {
  constructor() {
    this.loglocale = getLogLocale();
    if (isPublish) {
      if (this.loglocale.seed) {
        this.setLogCookie();
      } else {
        // https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
        this.guid();

        const xhr = new XMLHttpRequest();
        xhr.addEventListener('load', (r) => {
          let response = JSON.parse(r.target.response) || {};
          if (response && typeof response === 'object' && 'UniqueId' in response) {
            this.loglocale.seed = response.UniqueId;
          } else {
            this.loglocale.seed = this.guid();
          }

          this.setLogCookie();
        });
        xhr.addEventListener('error', () => {
          this.loglocale.seed = this.guid();

          this.setLogCookie();
        });
        xhr.open('GET', requestUrls.guid);
        xhr.send();
      }
    }
  }
  guid() {
    return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' +
      this.s4() + '-' + this.s4() + this.s4() + this.s4();
  }
  s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  setLogCookie() {
    document.cookie = `loglocale=${JSON.stringify(this.loglocale)};path=/;secure`;
  }
}

export default new Logging();
